<div mat-dialog-container>
  <div mat-dialog-content>
    <div class="close-row">
      <a (click)="close()">
        <img
          class="close-icon"
          src="assets/images/shared/Icon - Close - Active.svg"
        />
      </a>
    </div>
    <div class="modal-title grey-color">
      {{ "FOOTER.PRIVACY_PRINCIPAL" | translate }}
    </div>

    <div class="privacy-principles-body legal-notes">
      <div class="std-fs-s std-fs-md-xs std-fw-normal text-justify">
        <h1>{{ "FOOTER.PRIVACY_GENERAL" | translate }}</h1>
        <p>
          {{ "FOOTER.PRIVACY_GENERAL_BODY" | translate }}
        </p>
        <h1>{{ "FOOTER.PRIVACY_PERSONAL_DATA" | translate }}</h1>
        <p>
          {{ "FOOTER.PRIVACY_PERSONAL_DATA_BODY_1" | translate }}
          <br /><br />
          {{ "FOOTER.PRIVACY_PERSONAL_DATA_BODY_2" | translate }}
          <span
            (click)="downloadFile()"
            (keydown.enter)="downloadFile()"
            tabindex="0"
            role="button"
            class="link"
            >{{ "FOOTER.PRIVACY_HERE" | translate }}</span
          >.
        </p>

        <h1>{{ "FOOTER.PRIVACY_WEB_TRACKING" | translate }}</h1>
        <p>
          {{ "FOOTER.PRIVACY_WEB_TRACKING_BODY_1" | translate }}
          <br /><br />
          {{ "FOOTER.PRIVACY_WEB_TRACKING_BODY_2" | translate }}
          <br /><br />
          {{ "FOOTER.PRIVACY_WEB_TRACKING_BODY_3" | translate }}
          <br /><br />

          {{ "FOOTER.PRIVACY_WEB_TRACKING_BODY_4" | translate }}
        </p>
        <ul>
          <li>
            <p>{{ "FOOTER.PRIVACY_WEB_TRACKING_BULLET_1" | translate }}</p>
          </li>
          <li>
            <p>
              {{ "FOOTER.PRIVACY_WEB_TRACKING_BULLET_2" | translate }}
            </p>
          </li>
        </ul>
        <p>
          {{ "FOOTER.PRIVACY_WEB_TRACKING_BODY_5" | translate }}
          <br /><br />
          {{ "FOOTER.PRIVACY_WEB_TRACKING_BODY_6" | translate }}
          <br /><br />
          {{ "FOOTER.PRIVACY_WEB_TRACKING_BODY_7" | translate }}
          <a href="https://tools.google.com/dlpage/gaoptout" target="_blank"
            >https://tools.google.com/dlpage/gaoptout</a
          >. <br /><br />
        </p>
        <h1>{{ "FOOTER.PRIVACY_SOCIAL_MEDIA" | translate }}</h1>
        <br />
        <p>
          {{ "FOOTER.PRIVACY_SOCIAL_MEDIA_BODY_1" | translate }}
        </p>
        <ul>
          <li>
            <p>
              {{ "FOOTER.PRIVACY_SOCIAL_MEDIA_BULLET_1" | translate }}
            </p>
          </li>
          <li>
            <p>
              {{ "FOOTER.PRIVACY_SOCIAL_MEDIA_BULLET_2" | translate }}
            </p>
          </li>
        </ul>
        <p>
          {{ "FOOTER.PRIVACY_SOCIAL_MEDIA_BODY_2" | translate }}
          <br /><br />
          {{ "FOOTER.PRIVACY_SOCIAL_MEDIA_BODY_3" | translate }}
          <br /><br />
          {{ "FOOTER.PRIVACY_SOCIAL_MEDIA_BODY_4" | translate }}
        </p>

        <ul class="std-ta-left">
          <li>
            <p>
              <a
                href="https://de-de.facebook.com/about/privacy/"
                target="_blank"
              >
                Facebook: https://de-de.facebook.com/about/privacy/
              </a>
            </p>
          </li>
          <li>
            <p>
              <a
                href="https://developers.google.com/+/web/policies"
                target="_blank"
              >
                Google: https://developers.google.com/+/web/policies
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://twitter.com/privacy" target="_blank">
                Twitter: https://twitter.com/privacy
              </a>
            </p>
          </li>
          <li>
            <p>
              <a
                href="https://www.whatsapp.com/legal/#privacy-policy"
                target="_blank"
              >
                Whatsapp: https://www.whatsapp.com/legal/#privacy-policy
              </a>
            </p>
          </li>
          <li>
            <p>
              <a
                href="https://www.linkedin.com/legal/privacy-policy"
                target="_blank"
              >
                Linkedin: https://www.linkedin.com/legal/privacy-policy
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://messenger.com/privacy" target="_blank">
                Messenger: https://messenger.com/privacy
              </a>
            </p>
          </li>
        </ul>

        <h1>{{ "FOOTER.PRIVACY_QUERIES" | translate }}</h1>
        <p>
          {{ "FOOTER.PRIVACY_QUERIES_BODY_1" | translate }}
          <a href="mailto:privacy@allianz.com.my">
            privacy&#64;allianz.com.my
          </a>

          <br />
          {{ "FOOTER.PRIVACY_QUERIES_BODY_2" | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
